// src/components/ChargeOrderModal.jsx
import { useMemo, useState, useEffect } from "react";

const fmtCOP = n => (Number(n)||0).toLocaleString('es-CO',{style:'currency',currency:'COP',minimumFractionDigits:0});
const paymentOptions = ['Efectivo','Nequi','Bancolombia','BBVA','Daviplata','Rappi','Davivienda','Tarjeta Débito','Tarjeta Crédito','Otros'];

export default function ChargeOrderModal({
  open,
  order,             // { id?, table, items:[{id,name,price,quantity}], waiterName?, waiterUid? }
  currentUser,       // quien cobra (mesero o despacho)
  onClose,
  onConfirm,         // async ({paymentMethod, amount1, paymentMethod2?, amount2?}) => void
  loading = false,
  totalOverride = null,
}) {
  const itemTotal = useMemo(() => (order?.items||[]).reduce((s,i)=>s + Number(i.price||0)*Number(i.quantity||0),0), [order]);
  const total = Number.isFinite(Number(totalOverride)) ? Number(totalOverride) : itemTotal;
  const [pm1,setPm1] = useState('Efectivo');
  const [pm2,setPm2] = useState('');
  const [a1,setA1] = useState('');
  const [a2,setA2] = useState('');
  const received = (Number(a1)||0)+(Number(a2)||0);
  const missing = Math.max(0,total-received);
  const change  = Math.max(0,received-total);

  useEffect(()=>{ if(open){ setPm1('Efectivo'); setPm2(''); setA1(''); setA2(''); }},[open]);

  if(!open) return null;
  return (
    <div className="fixed inset-0 bg-black/40 grid place-items-center z-50">
      <div className="w-full max-w-md bg-white rounded-xl p-5 shadow-xl">
        <h3 className="text-xl font-bold mb-2">Cobrar pedido {order?.table ? `• ${order.table}` : ''}</h3>
        <div className="text-sm text-gray-600 mb-3">
          {order?.items?.length||0} ítems • Total: <b>{fmtCOP(total)}</b>
        </div>

        <div className="space-y-3">
          <div>
            <label className="text-sm font-medium">Método de pago principal</label>
            <select className="w-full border rounded-md p-2" value={pm1} onChange={e=>{setPm1(e.target.value); setA1('')}}>
              {paymentOptions.map(o=><option key={o} value={o}>{o}</option>)}
            </select>
          </div>
          <div>
            <label className="text-sm font-medium">Monto recibido ({pm1})</label>
            <input className="w-full border rounded-md p-2" inputMode="numeric" value={a1}
                   onChange={e=>setA1(e.target.value.replace(/\D/g,''))} placeholder="ej. 50000" />
          </div>

          <details>
            <summary className="cursor-pointer text-sm text-gray-700">+ Segundo método de pago (opcional)</summary>
            <div className="mt-2 space-y-2">
              <select className="w-full border rounded-md p-2" value={pm2} onChange={e=>{setPm2(e.target.value); setA2('')}}>
                <option value="">Seleccionar…</option>
                {paymentOptions.map(o=> o!==pm1 && <option key={o} value={o}>{o}</option>)}
              </select>
              <input className="w-full border rounded-md p-2" inputMode="numeric" value={a2}
                     onChange={e=>setA2(e.target.value.replace(/\D/g,''))}
                     placeholder={missing>0?`Sugerido: ${fmtCOP(missing)}`:'0'} />
            </div>
          </details>

          <div className="flex justify-between font-semibold mt-1">
            {missing>0
              ? <><span className="text-red-600">Faltan:</span><span className="text-red-600">{fmtCOP(missing)}</span></>
              : <><span className="text-green-600">Cambio:</span><span className="text-green-600">{fmtCOP(change)}</span></>}
          </div>

          <div className="flex gap-2 pt-3">
            <button onClick={onClose} className="flex-1 border rounded-md p-2">Cancelar</button>
            <button
              disabled={missing>0 || total===0 || loading}
              onClick={()=>onConfirm({
                paymentMethod: pm1,
                amount1: Number(a1)||0,
                paymentMethod2: pm2 || null,
                amount2: pm2 ? (Number(a2)||0) : 0
              })}
              className="flex-1 bg-blue-600 text-white rounded-md p-2 disabled:opacity-60">
              {loading ? 'Procesando...' : 'Cobrar y Facturar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
